export const VIVIER_SEARCH_OPTIONS = [
  { value: '', label: 'Tous' },
  { value: 'id_bestt', label: 'ID BeSTT' },
  { value: 'name', label: 'Nom' },
  { value: 'mail', label: 'Email' },
  { value: 'phone', label: 'Téléphone' },
];

export const COMPANY_SEARCH_OPTIONS = [
  { value: '', label: 'Tous' },
  { value: 'id_company', label: 'ID Entreprise' },
  { value: 'name_company', label: 'Nom entreprise' },
  { value: 'group_company', label: 'Groupe' },
  { value: 'employee_name', label: 'Nom employé' },
  { value: 'employee_email', label: 'Email employé' },
  { value: 'employee_phone', label: 'Téléphone employé' },
  { value: 'siret', label: 'Siret' },
];
